import "./styles/style.scss";

import { initSitePollBlocks } from "./poll-front.js";

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initSitePollBlocks);
} else {
	initSitePollBlocks();
}
